import IGeoCoordinate from "./IGeoCoordinate";
import Shape from "./Shape";

export default interface ITenantInMarket {
    id: number;
    shape: Shape;
    description: string | null;
    pipedriveCompanyId: number | null;
    pipedriveBrokerageId: number | null;
    landAreaMin: number;
    landAreaMax: number;
    buildingAreaMin: number;
    buildingAreaMax: number;
    notes: string | null;
    useType: string | null;
    contact: string | null;
    targetAnnualRent: number | null;
    zoningRequired: string | null;
    siteConditions: string | null;
    timing: string | null;
    companyWebsite: string | null;
    corpOwnership: CorpOwnership | null;
    revenue: string | null;
    numberOfEmployees: number | null;
    numberOfLocations: number | null;
    inactiveReason: string | null;
    assignedToPipedriveUserId: number;
    modifiedByUser: string | null;
    modifiedDate: Date;
    createdAt: Date;
}

export interface ITenantInMarketResponseModel {
    id: number;
    shape: IGeoCoordinate[];
    landAreaMin: number;
    landAreaMax: number;
    buildingAreaMin: number;
    buildingAreaMax: number;
    notes: string | null;
    useType: string | null;
    contact: string | null;
    targetAnnualRent: number | null;
    zoningRequired: string | null;
    siteConditions: string | null;
    timing: string | null;
    companyWebsite: string | null;
    corpOwnership: CorpOwnership | null;
    revenue: string | null;
    numberOfEmployees: number | null;
    numberOfLocations: number | null;
    description: string | null;
    pipedriveCompanyId: number | null;
    pipedriveBrokerageId: number | null;
    inactiveReason: string | null;
    assignedToPipedriveUserId: number;
    modifiedByUser: string | null;
    modifiedDate: string;
    createdAt: string;
}

export interface ITenantInMarketRequestModel {
    id?: number;
    shape: IGeoCoordinate[];
    landAreaMin: number;
    landAreaMax: number;
    buildingAreaMin: number;
    buildingAreaMax: number;
    notes: string | null;
    useType: string | null;
    contact: string | null;
    targetAnnualRent: number | null;
    zoningRequired: string | null;
    siteConditions: string | null;
    timing: string | null;
    companyWebsite: string | null;
    corpOwnership: CorpOwnership | null;
    revenue: string | null;
    numberOfEmployees: number | null;
    numberOfLocations: number | null;
    description: string | null;
    pipedriveCompanyId: number | null;
    pipedriveBrokerageId: number | null;
    inactiveReason: string | null;
    assignedToPipedriveUserId: number;
    geography?: string;
}

export interface ITenantInMarketState {
    description: string | null;
    pipedriveCompanyName: string | null;
    pipedriveBrokerageName: string | null;
    landAreaMin: number | null;
    landAreaMax: number | null;
    buildingAreaMin: number | null;
    buildingAreaMax: number | null;
    notes: string | null;
    useType: string | null;
    contact: string | null;
    targetAnnualRent: number | null;
    zoningRequired: string | null;
    siteConditions: string | null;
    timing: string | null;
    companyWebsite: string | null;
    corpOwnership: CorpOwnership | null;
    revenue: string | null;
    numberOfEmployees: number | null;
    numberOfLocations: number | null;
    inactiveReason: string | null;
    assignedToPipedriveUserId: number | null;
}

export class TenantInMarketState implements ITenantInMarketState {
    description: string | null = null;
    pipedriveCompanyName: string | null = null;
    pipedriveBrokerageName: string | null = null;
    landAreaMin: number | null = null;
    landAreaMax: number | null = null;
    buildingAreaMin: number | null = null;
    buildingAreaMax: number | null = null;
    notes: string | null = null;
    useType: string | null = null;
    contact: string | null = null;
    targetAnnualRent: number | null = null;
    zoningRequired: string | null = null;
    siteConditions: string | null = null;
    timing: string | null = null;
    companyWebsite: string | null = null;
    corpOwnership: CorpOwnership | null = null;
    revenue: string | null = null;
    numberOfEmployees: number | null = null;
    numberOfLocations: number | null = null;
    inactiveReason: string | null = null;
    assignedToPipedriveUserId: number | null = null;

    static empty(): TenantInMarketState {
        return new TenantInMarketState();
    }
}

export enum CorpOwnership {
    Public = "Public",
    Private = "Private",
}